module.exports = __webpack_public_path__ + "img/adwords.046328a2.png";